import React,{useEffect} from 'react'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import FormikControl from '../../hoc/formikComponents/FormikControl'
import { useMutation } from 'react-query'
import ToastInstance from '../../hoc/NotificationSettings/ToastInstance'
import { useHistory } from "react-router-dom";
import Fetcher from '../../hoc/FetcherSetting/FetcherSetting'


function SignIn() {
    const initialValues = {

        userCode: "",
        password: "",
    }

    const validationSchema = Yup.object({
        userCode: Yup.string().required('Required!!'),
        password: Yup.string().required('Required!!'),
    })
    const onSubmit = values => {

        mutation.mutate(values)
    }
    const mutation = useMutation((params) => Fetcher('post', '/api/user/post/login', params), {
        onSuccess(data) {

            if (data.data.errorCode === 0) {
                ToastInstance('Success', 'User Logined In')
                localStorage.setItem("userCode", data.data.response.userCode)
                localStorage.setItem("role", data.data.response.role)
                localStorage.setItem("fullName", data.data.response.fullName)
                
                localStorage.setItem("token", data.data.response.token)
                localStorage.setItem("userRole", data.data.response.userRole)
                localStorage.setItem("emails", data.data.response.emails)
                console.log("role on sign in",data.data.response)
                if (data.data.response.role === 'admin') {
                    window.location.href = '/admin/auditlist';
                } else {
                   
                    if(data.data.response.userRole === 'Client' || data.data.response.userRole === 'Executive(Support)'){
                      
                       window.location.href ='/user/rfq'
                    }
                    else
                    { 
                       window.location.href = '/user/auditlist';
                    }
                }
            } else {
                var msg = 'User Not Registered - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'User Not Registered' + error)
        }
    })
     useEffect(() => {
        localStorage.setItem("userCode","")
        localStorage.setItem("role","")
        localStorage.setItem("firstName","")
        localStorage.setItem("lastName", "")
        localStorage.setItem("token", "")
        localStorage.setItem("userRole","")
        localStorage.setItem("emails","")
     }, [])
    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
        >
            {
                formik =>
                    // <div className="signOuterDiv">
                    <Form>
                        <div className="hold-transition loginpage">
                            <div className="login-box">
                                <div className="row text-center">
                                    <h4>Audit Application Login</h4>
                                </div>
                                <br></br>
                                <div className="login-box-body">
                                    <div className="form-group has-feedback">
                                        <FormikControl control='input' type="text" name='userCode' label="User Code *" placeholder="User Code/E-mail Id" className="form-control"  />

                                        <span className="glyphicon glyphicon-envelope form-control-feedback" />

                                    </div>
                                    <br></br>
                                    <div className="form-group has-feedback">
                                        <FormikControl control='input' type='password' name='password' label="Password *" placeholder="Password" className="form-control" />
                                        <span className="glyphicon glyphicon-envelope form-control-feedback" />
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-10">
                                            <a href="/forgotPassword">Forgot Password</a>
                                        </div>
                                    </div>
                                    <br />
                                    <div classname="row" style={{ marginLeft: "65%" }}>

                                        <button type="submit" className="btn btn-primary" disabled={!formik.isValid}>Login</button>


                                    </div>
                                </div>
                            </div>

                        </div>
                    </Form>

            }
        </Formik>
    )
}

export default SignIn
